const BRANDS_PER_PAGE = 40;
const DEFAULT_SORT = "most_popular";

const DISCOUNT_FILTER_LIST = [
  {
    name: "0% - 5%",
    value: "0.01-5"
  },
  {
    name: "5% - 10%",
    value: "5-10"
  },
  {
    name: "10% - 20%",
    value: "10-20"
  },
  {
    name: "20% - 30%",
    value: "20-30"
  },
  {
    name: "30% +",
    value: "30-100"
  }
];

const CASHBACK_FILTER_LIST = [
  {
    name: "0% - 5%",
    value: "0.01-5"
  },
  {
    name: "5% - 10%",
    value: "5-10"
  },
  {
    name: "10% +",
    value: "10-100"
  }
];

const CARD_TYPE_FILTER_LIST = [
  {
    name: "Physical",
    value: "physical"
  },
  {
    name: "Electronic",
    value: "electronic"
  }
];

const STATIC_FILTERS = {
  savings: DISCOUNT_FILTER_LIST,
  cash_back: CASHBACK_FILTER_LIST,
  card_type: CARD_TYPE_FILTER_LIST,
  name: ""
};

export { BRANDS_PER_PAGE, DEFAULT_SORT, STATIC_FILTERS };
